import {ActionIcon, Flex, Table, Text} from '@mantine/core'
import {NoProjectWarning} from './components/NoProjectWarning.tsx'
import {ProjectBadge} from '../calendar/components/badges/ProjectBadge.tsx'
import type {GitHubRepository} from '@package/shared'
import {IconExternalLink} from '@tabler/icons-react'

type Props = {
  repository: GitHubRepository
  onClick: () => void
}

export const RepositoryRow = ({repository, onClick}: Props) => {
  return (
    <Table.Tr
      key={repository.id}
      onClick={(e) => {
        if (e.isDefaultPrevented()) return
        onClick()
      }}
      style={{cursor: 'pointer'}}
    >
      <Table.Td />

      <Table.Td width={0}>
        <Flex gap={5} pl={15}>
          <Text size={'sm'}>{repository.name}</Text>
          <ActionIcon
            variant={'subtle'}
            size={'sm'}
            onClick={(e) => {
              e.preventDefault()
              window.open(`https://github.com/${repository.name}`, '_blank')
            }}
            title={'Open GitHub'}
          >
            <IconExternalLink stroke={1} />
          </ActionIcon>
        </Flex>
      </Table.Td>

      <Table.Td>
        <Flex gap={5} wrap={'wrap'}>
          {!repository.projectId && <NoProjectWarning variant={'tooltip'} />}
          {repository.projectId && <ProjectBadge projectId={repository.projectId} />}
        </Flex>
      </Table.Td>

      <Table.Td />
    </Table.Tr>
  )
}
